// utils/api.js
import axios from "axios";
import { decrypt } from "./cryptoUtils";
import { AxiosError } from "../components/sessionexpiry";

const API_BASE_URL = "https://enterprises.gaadiaa.com";

export const login = async (encrypted) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/login`, {
      encrypted,
    });

    // Log the API response for debugging
    //console.log("API Response:", JSON.stringify(response.data.data, null, 2));
    // Decrypt the response data
    const decryptedResponse = decrypt(response.data.data);

    // Parse the decrypted response into an object
    const decryptreponse = JSON.parse(decryptedResponse);

    //console.log("API Response:", decryptreponse);

    sessionStorage.setItem("users", JSON.stringify(decryptreponse, null, 2));
    sessionStorage.setItem("token", decryptreponse.token);

    // Check if the response status is successful
    if (decryptreponse.Status === "200") {
        return decryptreponse;
    } else {
      // Handle non-200 status
      throw new Error(decryptreponse.token || "Login failed");
    }
  } catch (error) {
    // Log the error details for debugging
    console.error("API Error:", JSON.stringify(error.response?.data, null, 2));

    // Throw an error with a user-friendly message
    throw new Error(error.response?.data?.msg || "Login failed");
  }
};

export const signup = async (encrypted) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/register`, {
      encrypted,
    });

    // Log the API response for debugging
    console.log("API Response:", JSON.stringify(response.data.data, null, 2));
    // Decrypt the response data
    const decryptedResponse = decrypt(response.data.data);

    // Parse the decrypted response into an object
    const decryptreponse = JSON.parse(decryptedResponse);

    console.log("API Response:", JSON.stringify(decryptreponse, null, 2));

    // Check if the response status is successful
    if (decryptreponse.Status === "200") {

        console.log(decryptreponse)

        // Return the response data for further use
        return decryptreponse;
    } else {
      // Handle non-200 status
      throw new Error(decryptreponse.msg || "Login failed");
    }
  } catch (error) {
    // Log the error details for debugging
    console.error("API Error:", JSON.stringify(error.response?.data, null, 2));

    // Throw an error with a user-friendly message
    throw new Error(error.response?.data?.msg || "Login failed");
  }
};


export const logout = async () => {
  try {
    const token = sessionStorage.getItem("token");

    await axios.get(`${API_BASE_URL}/auth/logout`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true, // If your API uses cookies/sessions
    });

    // Clear session storage
    sessionStorage.removeItem("reduxState");
    sessionStorage.removeItem("token");

    // Optional: Reload the page or redirect the user to login
    window.location.href = "/login";
  } catch (error) {
    throw new Error(error.response?.data?.message || "Logout failed");
  }
};

export const Report = async (method, endpoint, navigate) => {
  const token = sessionStorage.getItem("token");

  try {
    const response = await axios({
      method,
      url: `${API_BASE_URL}/api/v1${endpoint}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob", // 🔥 Must be blob for file
    });

    return response; // Return full response (NOT just data)
  } catch (error) {
    console.error("API error:", error);
    throw new Error(error.response?.data?.message || "Download failed");
  }
};

// Function to check if the user is authenticated
export const isAuthenticated = () => {
  return !!sessionStorage.getItem("token");
};

// Function to get user data from session storage
export const getUser = () => {
  const user = sessionStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

// Function to make authenticated API calls
export const makeAuthenticatedRequest = async (method, endpoint, data = {} , navigate) => {
  const token = sessionStorage.getItem("token");

  try {
    const response = await axios({
      method,
      url: `${API_BASE_URL}${endpoint}`,
      data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data.data;
  } catch (error) {
    AxiosError(navigate, error)
    throw new Error(error.response?.data?.message || "Request failed");
  }
};